export default "__VITE_ASSET__Cod3AwqU__"